import { asyncActionsCreator } from "@webiz/redux-common";
import {
  AUTHENTICATE, GET_USER, LOGOUT,
} from "./AuthTypes";

export const authenticateActions = asyncActionsCreator(AUTHENTICATE);
export const logOutActions = asyncActionsCreator(LOGOUT);
export const getUserActions = asyncActionsCreator(GET_USER);
